'use client';
import { Table } from 'antd';
import { Entering, LoadingLogo, Pagination, Typography } from 'components';
import { EmptyInboxClipArt } from 'lib/svgs/ClipArts';
import { useTranslations } from 'next-intl';

import { Payment } from 'gql/graphql';
import { InfoHollowIcon } from 'lib/svgs/Icons';
import 'styles/sass/ant-design/ant-design-table-checkbox.scss';
import FilterSortPayments from './_components/FilterSortPayments';
import { usePaymentsContext } from './_context/PaymentsContext';

export default function PaymentsPage() {
  const t = useTranslations();

  const { isLoading, isPending, page, setPage, totalPages, isRetrieving, columns, payments } =
    usePaymentsContext();

  return (
    <div className="mt-6">
      <Entering offset={5} delay={0.6} duration={0.2} position="bottom" className="gap-10">
        <div className="mt-1">
          <Entering
            offset={5}
            delay={0.6}
            position="bottom"
            className="rounded-t-md bg-white shadow-custom"
          >
            <div className="flex justify-between !p-4 !px-6">
              <Typography
                variant="medium1"
                className="relative left-0 top-0 flex items-center text-tertiary-100"
              >
                <span className="flex gap-2">
                  {t('billing.payments.title')}
                  <span className="text-tertiary-200">({payments?.nodesCount})</span>
                </span>
                <a
                  data-tooltip-id="tolq-info-top-start"
                  data-tooltip-html={t('billing.payments.info')}
                >
                  <InfoHollowIcon className="scale-[0.5] cursor-pointer pb-1" />
                </a>
              </Typography>
              <span className="flex gap-4">
                <FilterSortPayments />
              </span>
            </div>
            {(isLoading || isPending) && (
              <div className="grid h-[50vh] flex-1 place-content-center">
                <div className="relative flex flex-col items-center justify-center">
                  <LoadingLogo size="x-small" className="absolute -left-8" />
                </div>
              </div>
            )}

            {!(isLoading || isPending) && !!payments?.nodes?.length && (
              <Table<Payment>
                key={`${page}`}
                tableLayout="auto"
                columns={columns}
                dataSource={payments?.nodes || []}
                pagination={false}
                scroll={{
                  x: true
                }}
              />
            )}
            {!(isLoading || isPending) && (!payments || payments?.nodes?.length === 0) && (
              <div className="grid h-[50vh] flex-1 place-content-center">
                <div className="flex flex-col items-center justify-center">
                  <EmptyInboxClipArt />
                  <Typography
                    variant="light3"
                    className="flex max-w-[250px] text-center text-tertiary-200"
                  >
                    {t('billing.payments.empty')}
                  </Typography>
                </div>
              </div>
            )}
            {!!totalPages && !!page && !isRetrieving && (
              <Pagination
                totalPages={totalPages}
                changePage={setPage}
                page={page}
                className="flex justify-center pb-8 pt-6"
              />
            )}
          </Entering>
        </div>
        <div className="flex justify-center py-10" />
      </Entering>
    </div>
  );
}
